import React from 'react'
import './Dashboard.css';

export default function DashboardList({ listItems = [] }) {
  if (listItems && listItems.length < 2) return <p>Sin usuarios en línea</p>;
  const headers = Object.keys(listItems[0]);
  return (
    <table className={'dash-table'}>
      <thead>
        <tr>
          {headers.map((h) => <td key={h}>{h}</td>)}
        </tr>
      </thead>
      <tbody>
        {
          listItems.map((item, li) => (
            <tr key={li}>
              {headers.map((h) => <td key={item[h]}>{item[h]}</td>)}
            </tr>
          ))
        }
      </tbody>
    </table>
  )
}
